import { Inject, Injectable } from '@angular/core';
import { PacimUtilityEntity } from '../enumeration';
import { HandleError, HttpUtility, PacimHttpErrorHandlerService } from '../http';
import { API_BASE_PACIM_URL } from './config.service';
import { UtilityPacimService } from './utilities.service';

@Injectable()
export class BarrierReviewUtilityPacimService extends UtilityPacimService {
  entityType = PacimUtilityEntity.BarrierReview;

  handleError: HandleError;

  constructor(
    httpUtility: HttpUtility,
    @Inject(API_BASE_PACIM_URL) apiBaseUrl: string,
    pacimHttpErrorHandler: PacimHttpErrorHandlerService
  ) {
    super(httpUtility, apiBaseUrl);
    this.handleError = pacimHttpErrorHandler.createHandleError('BarriersToDischargeUtilityPacimService');
  }
}
